/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: userAccountReducers.js
 *
 * Created by robertcaslin.
 */

import {ACCOUNT_CREATE_START, ACCOUNT_CREATE_SUCCESS, ACCOUNT_CREATE_ERROR} from "../actions/userActions";

const initialState = {
    isFetching:false,
    isAuthenticated: !!localStorage.getItem('auth_token'),
    accountCreated: !!localStorage.getItem('auth_token')

};

export default function createAccount(state = initialState, action){
    switch(action.type){
        case ACCOUNT_CREATE_START:
            return {...state,
                isFetching:true,
                isAuthenticated:false,
            };

        case ACCOUNT_CREATE_SUCCESS:
            return {...state,
                isFetching:false,
                isAuthenticated:true,
                errorMessage: ''
            };

        case ACCOUNT_CREATE_ERROR:
            return {...state,
                isFetching:false,
                isAuthenticated:false,
                errorMessage: action.message
            };

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userAccountReducers.js